import React from 'react'
import { useSelector } from 'react-redux'

function PriceBox({price, currentPlan, getPlanName}) {
    const priceKwhPos = useSelector((user) => user.user.nuoviDatiContratto.mono_positivo)
    const priceKwhNeg = useSelector((user) => user.user.nuoviDatiContratto.mono_negativo)
    const opzioneTariffaria = useSelector((user) => user.user.info.opzione_tariffaria)
    const quotaFissaPos = useSelector((user) => user.user.nuoviDatiContratto.qf_positivo)
    const quotaFissaNeg = useSelector((user) => user.user.nuoviDatiContratto.qf_negativo)

    return (
        <>
            {currentPlan === 3 ? (
                <div className="priceBox">
                    <p className='label'>Prezzo</p>
                    <p className='sulLabel'>Applicato a tutti i consumi</p>
                    <p className='price flex'>{parseFloat(price).toFixed(2).replace(/\./g, ",")}<span> €/kWh</span>
                        {opzioneTariffaria && opzioneTariffaria !== 'D2' ? (
                            <p className='quotaFissa'>+ {parseFloat(quotaFissaNeg).toFixed(2).replace(/\./g, ",")} € al giorno</p>
                        ) : null}
                    </p>
                    {opzioneTariffaria && opzioneTariffaria !== 'D2' && opzioneTariffaria !== 'D3' ? (
                            <p className='iva'>IVA da aggiungere</p>
                    ) : null}
                    <p className='plus'>Non sono previsti sconti o bonus per il piano {getPlanName}</p>
                </div>
            ) : currentPlan === 2 ? (
                <div className="priceBox">
                    <p className='label'>Prezzo</p>
                    <p className='sulLabel'>Applicato in base al consumo mensile</p>
                    <p className='price flex'>{parseFloat(price - 0.02).toFixed(2).replace(/\./g, ",")}<span> €/kWh</span>
                        {opzioneTariffaria && opzioneTariffaria !== 'D2' ? (
                            <p className='quotaFissa'>+ {parseFloat(quotaFissaNeg).toFixed(2).replace(/\./g, ",")} € al giorno</p>
                        ) : null}
                    </p>
                    {opzioneTariffaria && opzioneTariffaria !== 'D2' && opzioneTariffaria !== 'D3' ? (
                            <p className='iva'>IVA da aggiungere</p>
                    ) : null}
                    <p className='plus'>Il prezzo scontato è applicato su tutti i kWh acquistati in anticipo. L'eventuale differenza sarà pagata a prezzo pieno.</p>
                </div>
            ) : (
                <div className="priceBox">
                    <p className='label'>Prezzo</p>
                    <p className='sulLabel'>Applicato in base al saldo giornaliero</p>
                    <div className='group'>
                        <div className="negativo">
                            <p>Negativo</p>
                            <p className='price'>{parseFloat(priceKwhNeg).toFixed(2).replace(/\./g, ",")}<span> €/kWh</span></p>
                            {opzioneTariffaria && opzioneTariffaria !== 'D2' ? (
                                <p className='quotaFissa'>+ {parseFloat(quotaFissaNeg).toFixed(2).replace(/\./g, ",")} € al giorno</p>
                            ) : null}
                             {opzioneTariffaria && opzioneTariffaria !== 'D2' && opzioneTariffaria !== 'D3' ? (
                                    <p className='iva'>IVA da aggiungere</p>
                            ) : null}
                        </div>
                        <div className="positivo">
                            <p>Positivo</p>
                            <p className='price'>{parseFloat(priceKwhPos).toFixed(2).replace(/\./g, ",")}<span> €/kWh</span></p>
                            {opzioneTariffaria && opzioneTariffaria !== 'D2' ? (
                                <p className='quotaFissa'>+ {parseFloat(quotaFissaPos).toFixed(2).replace(/\./g, ",")} € al giorno</p>
                            ) : null}
                             {opzioneTariffaria && opzioneTariffaria !== 'D2' && opzioneTariffaria !== 'D3' ? (
                                <p className='iva'>IVA da aggiungere</p>
                        ) : null}
                        </div>
                       
                    </div>
                    
                    <p className='plus'>Il prezzo scontato sarà applicato ai consumi giornalieri fin quando il saldo sarà a credito.</p>
                </div>
            )}
        </>
        
    )
}

export default PriceBox
